module.exports = __webpack_public_path__ + "assets/img/ai-output-text.92299654.svg";